<template>
  <base-display-widget :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners">
    <div :style="{backgroundColor:getTitleBgColor}" class="flex flex-nowrap a-center p-l-10 b-b h-40 o-hidden">
      <div :class="{'flex-1':iteminfo.config.datalist.length<=4,'m-r-20':iteminfo.config.datalist.length>4}" :key="index"
           @click="onMenuItemClick(index)"
           class="p-h-10"
           v-for="(items,index) in getshowdatalist">
        <div class="flex a-center j-center">
          <div :style="{color:getItemColor(index),borderBottom:getBorder(index)}"
               class="h-40 lh-40 text-center text-nowrap relative bottom-0 d-inline-block fs-14">{{ items.name }}
          </div>
        </div>
      </div>
    </div>
<!--    <div style="min-height: 100px" v-if="getContent.type === 1">-->
    <div style="min-height: 100px">
      <span style="word-break: break-all;white-space: normal">{{getContent.linkUrl}}</span>
    </div>
<!--    <div style="min-height: 100px" v-if="getContent.type === 2">-->
<!--      <ul class="p-5">-->
<!--        <li :key="index" v-for="(item,index) in getContent.list">-->
<!--          <div v-if="item.srcType === 1">-->
<!--            <img :src="getItemPic(item)" alt="" class="w-full" style="cursor: pointer;vertical-align: top"/>-->
<!--          </div>-->
<!--          <div v-if="item.srcType === 2">-->
<!--            <ratio-div :RadioValue="63">-->
<!--              <div class="w-full h-full absolute top-0 left-0">-->
<!--                <div class="w-full h-full relative">-->
<!--                  <img :src="getdefaultVideoImg(item)"-->
<!--                       class="w-full h-full"-->
<!--                       style="cursor: pointer"/>-->
<!--                  <div class="flex a-center j-center"-->
<!--                       style="position: absolute;top:0;left:0;width: 100%;height: 100%" v-if="item.videoUrl">-->
<!--                    <i class="icon-player fs-40 text-white"></i>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </ratio-div>-->
<!--            <div class="p-5" v-if="item.title">-->
<!--              {{item.title}}-->
<!--            </div>-->
<!--          </div>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->
  </base-display-widget>
</template>

<script>
import BaseDisplayWidget from '../base/BaseDisplayWidget'
import RatioDiv from '../../common/RatioDiv'

export default {
  name: 'MenuDisplayWidget',
  components: {RatioDiv, BaseDisplayWidget},
  props: {
    selected: Boolean,
    showHeight: Number,
    iteminfo: {
      type: Object,
      default: () => {
        return {
          config: {
            topMargin: 0,
            itemsAlign: 1,
          },
          datalist: [{
            title: this.editText || '菜单' + (this.iteminfo.config.datalist.length + 1),
            type: 1, //1 链接地址  2 非链接地址
            linkUrl: '',
            isEdit: false,
            list: [{
              srcType: 1, //1 图片  2 视频,
              title: '',   //视频标题
              coverImgUrl: '',//封面或者图片，
              videoUrl: '',    //视频地址
              process: ''
            }]
          }]
        }
      }
    }
  },
  data () {
    return {
      selectindex: 0,
    }
  },
  computed: {
    getTitleBgColor () {
      if (this.iteminfo.config.menuBgColor) {
        return this.iteminfo.config.menuBgColor
      } else {
        return 'white'
      }
    },
    getContent () {
      let obj = null
      if (this.iteminfo.config.datalist && this.iteminfo.config.datalist.length) {
        if (!(this.selectindex < this.iteminfo.config.datalist.length)) {
          this.selectindex = 0
        }
        obj = this.iteminfo.config.datalist[this.selectindex]
      }
      return obj
    },
    getshowdatalist () {
      let list = []
      list = this.getDefaultProductList()
      return list
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    onMenuItemClick (index) {
      this.selectindex = index
    },
    getItemColor (index) {
      if (index === this.selectindex) {
        return this.iteminfo.config.fontcolor || '#399DFF'
      } else {
        return this.iteminfo.config.unfontcolor || '#333333'
      }
    },
    getSelectColor (index) {
      if (index === this.selectindex) {
        return this.iteminfo.config.wBgColor
      }
    },
    getBorder (index) {
      if (index === this.selectindex) {
        return '1px solid ' + (this.iteminfo.config.fontcolor || '#399DFF')
      } else {
        return 'none'
      }
    },
    ondel () {
      this.$emit('ondel')
    },
    getItemPic (item) {
      let src = require('../../../assets/tempmenu/img_picture_single.png')
      if (item.coverImgUrl) {
        src = item.coverImgUrl
      }
      return src
    },
    getdefaultVideoImg (item) {
      let src = require('../../../assets/tempmenu/img_video_single.png')
      if (item.coverImgUrl) {
        src = item.coverImgUrl
      } else if (item.videoUrl) {
        src = item.videoUrl + '?x-oss-process=video/snapshot,t_1000,f_png,w_0,h_0'
      }
      return src
    },
    getDefaultProductList () {
      // let templist = []
      // let length = 2
      // let len = this.iteminfo.config.datalist.length || 0
      // if (length <= len) {
      //   templist = this.iteminfo.config.datalist
      // } else {
      //   templist = templist.concat(this.iteminfo.config.datalist)
      //   for (let i = 0; i < (length - len); i++) {
      //     templist.push({
      //       title: this.editText || '菜单' + (this.iteminfo.config.datalist.length + 1),
      //       type: 1, //1 链接地址  2 非链接地址
      //       linkUrl: '',
      //       isEdit: false,
      //       list: [{
      //         srcType: 1, //1 图片  2 视频,
      //         title: '',   //视频标题
      //         coverImgUrl: '',//封面或者图片，
      //         videoUrl: '',    //视频地址
      //         process: ''
      //       }]
      //     })
      //   }
      // }
      // return templist
      return this.iteminfo.config.datalist
    },
  }
}
</script>

<style lang="scss" scoped>
  .activite-style {
    color: #399DFF;
    border-bottom: 2px solid #399DFF;
  }


  .h-actite-style {
    /*background: white;*/
    transition: all .3s ease-in-out;
  }
</style>
